import { render, staticRenderFns } from "./CompanySearchPage.vue?vue&type=template&id=10b547c8&scoped=true"
import script from "./CompanySearchPage.vue?vue&type=script&lang=js"
export * from "./CompanySearchPage.vue?vue&type=script&lang=js"
import style0 from "./CompanySearchPage.vue?vue&type=style&index=0&id=10b547c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b547c8",
  null
  
)

export default component.exports